import { render, staticRenderFns } from "./ChatMessageContent.vue?vue&type=template&id=72486bc4&scoped=true"
import script from "./ChatMessageContent.vue?vue&type=script&lang=js"
export * from "./ChatMessageContent.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageContent.vue?vue&type=style&index=0&id=72486bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72486bc4",
  null
  
)

export default component.exports